/* RapidPlas — hide the floating "Expert Advice & Project Support" widget on the
   cart page. It overlaps the delivery outcomes and the action buttons, which is
   the information the shopper needs to act on.

   The widget comes from an app, not the theme, so there is no stable class to
   target. It is located by its own label and the nearest fixed-position
   ancestor is hidden. Scoped to the cart page and to that phrase, so nothing
   else on the site is affected. */
(function () {
  'use strict';

  var NEEDLE = 'expert advice';
  var MAX_LABEL_LENGTH = 80;
  var hidden = false;

  function hideWidget() {
    if (hidden) return true;

    var candidates = document.querySelectorAll('div, section, aside, a, button, span');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.closest('.rp-cart-layout')) continue; // never touch our own UI

      var text = (el.textContent || '').trim().toLowerCase();
      if (!text || text.length > MAX_LABEL_LENGTH) continue;
      if (text.indexOf(NEEDLE) === -1) continue;

      // walk up to the floating container and hide that, not just the label
      var node = el;
      while (node && node !== document.body) {
        var position = '';
        try { position = window.getComputedStyle(node).position; } catch (e) { position = ''; }
        if (position === 'fixed' || position === 'sticky') {
          node.style.setProperty('display', 'none', 'important');
          hidden = true;
          return true;
        }
        node = node.parentElement;
      }

      el.style.setProperty('display', 'none', 'important');
      hidden = true;
      return true;
    }
    return false;
  }

  function watch() {
    hideWidget();
    // the app loads asynchronously, so keep looking for a short while
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (hideWidget() || tries > 20) clearInterval(timer);
    }, 500);

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        if (hideWidget()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 15000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
